import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

// 卡牌版本接口
export interface CardVersion {
  id: number;
  name: string;
  sort: number;
  card_language_id?: number;
  card_language_name?: string;
  cards_count?: number;
  created_at: string;
  updated_at: string;
}

// 下拉选项接口
export interface CardVersionOption {
  id: number;
  name: string;
  card_language_id?: number;
}

@Module
export default class CardVersionModule extends VuexModule {
  card_version_list = [] as Array<CardVersion>;
  card_version_count = 0;
  card_version = {} as CardVersion;
  all_card_versions = [] as Array<CardVersionOption>;

  get currentCardVersionList(): Array<CardVersion> {
    return this.card_version_list;
  }

  get currentCardVersion(): CardVersion {
    return this.card_version;
  }

  get currentCardVersionCount(): number {
    return this.card_version_count;
  }

  get currentAllCardVersions(): Array<CardVersionOption> {
    return this.all_card_versions;
  }

  @Mutation
  [Mutations.SET_CARD_VERSION_LIST](card_version_list: Array<CardVersion>) {
    this.card_version_list = card_version_list;
  }

  @Mutation
  [Mutations.SET_CARD_VERSION](card_version: CardVersion) {
    this.card_version = card_version;
  }

  @Mutation
  [Mutations.SET_CARD_VERSION_COUNT](count: number) {
    this.card_version_count = count;
  }

  @Mutation
  [Mutations.SET_ALL_CARD_VERSIONS](all_card_versions: Array<CardVersionOption>) {
    this.all_card_versions = all_card_versions;
  }

  @Action
  [Actions.GET_CARD_VERSION_LIST](params: Record<string, unknown>) {
    ApiService.setHeader();

    let queryString = "?";
    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          queryString += "&" + key + "=" + params[key];
        }
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/card_versions", queryString)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_CARD_VERSION_LIST, data["card_versions"] || []);
          this.context.commit(Mutations.SET_CARD_VERSION_COUNT, data["total_result"] || 0);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }

  @Action
  [Actions.GET_CARD_VERSION](id: number) {
    ApiService.setHeader();

    return new Promise<void>((resolve, reject) => {
      ApiService.get(`admin/card_versions/${id}`)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_CARD_VERSION, data["card_version"]);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }

  @Action
  [Actions.CREATE_CARD_VERSION](params: Record<string, unknown>) {
    ApiService.setHeader();

    return new Promise<{ success: boolean; error_msg?: string }>((resolve, reject) => {
      ApiService.post("admin/card_versions", { card_version: params })
        .then(({ data }) => {
          if (data.success) {
            this.context.commit(Mutations.SET_CARD_VERSION, data["card_version"]);
          }
          resolve(data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject(response?.data);
        });
    });
  }

  @Action
  [Actions.UPDATE_CARD_VERSION](credentials: { id: number; values: Record<string, unknown> }) {
    ApiService.setHeader();

    return new Promise<{ success: boolean; error_msg?: string }>((resolve, reject) => {
      ApiService.put(`admin/card_versions/${credentials.id}`, { card_version: credentials.values })
        .then(({ data }) => {
          if (data.success) {
            this.context.commit(Mutations.SET_CARD_VERSION, data["card_version"]);
          }
          resolve(data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject(response?.data);
        });
    });
  }

  @Action
  [Actions.DELETE_CARD_VERSION](id: number) {
    ApiService.setHeader();

    return new Promise<{ success: boolean; error_msg?: string }>((resolve, reject) => {
      ApiService.delete(`admin/card_versions/${id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject(response?.data);
        });
    });
  }

  @Action
  [Actions.GET_ALL_CARD_VERSIONS](params?: { card_language_id?: number }) {
    ApiService.setHeader();

    let queryString = "";
    if (params?.card_language_id) {
      queryString = `?card_language_id=${params.card_language_id}`;
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/card_versions/all", queryString)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_ALL_CARD_VERSIONS, data["card_versions"] || []);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }
}
